import "./footer.scss";
import FooterLogo from "../../assets/logo.png";
import Grid from '@material-ui/core/Grid';
import {TwitterCircleFilled,FacebookFilled} from "@ant-design/icons";
import MapOutlinedIcon from '@material-ui/icons/MapOutlined';
import CallOutlinedIcon from '@material-ui/icons/CallOutlined';
import MailOutlinedIcon from '@material-ui/icons/MailOutlined';


const Footer = () => {
  return(
  <footer className="footer-container">

  <Grid container>
        <Grid item xs={4}>
          <div className="main-right-footer">
            <div className="footer-who-we-are">
                <img id="footer-logo" className="shawi-footer-logo-img" src={FooterLogo} alt="footer-logo" />
                <p className="footer-item-description">مؤسسة خيرية مانحة ، مرخصة من وزارة الشؤون الاجتماعية برقم (54) ، تنطلق في عملها من خلال تبني ودعم المؤسسات الخيرية والجهات العاملة في الساحة بما يتوافق مع المجالات التي حددها فضيلة الشيخ محمد بن صالح الشاوي حفظه الله.</p>
            </div>
            <div className="footer-follow-us">
              <h2 className="follow-us-headline">تابعنا على </h2>
                  <ul className="footer-social-links">
                    <li><a href="https://www.facebook.com/msalshawi" target="_blank"><FacebookFilled className="icon-footer" /></a></li>
                    <li><a href="https://twitter.com/alshawicharity" target="_blank"><TwitterCircleFilled className="icon-footer"/></a></li>

                </ul>
            </div>
          </div>
        </Grid>
        <Grid item xs={8}>
            <div className="main-left-footer">

                  <div className="contact-us-footer">
                    <h2 className="contact-us-headline">تواصل معنا </h2>  
                        <div className="contact-us-location"> 
                          <a href="https://goo.gl/maps/adZEiLbjwMtAjmoAA" target="_blank"><MapOutlinedIcon/> الرياض-حي الريان مخرج14-شارع عنيزة متقاطع مع <br/> شارع أحمد بن حنبل مقابل لمستشفى رعاية (شمالا) </a>
                        </div>
                       <div className="call-mail">
                          <ul>
                            <li> <a href="tel:+966114913115" target="_blank"> <CallOutlinedIcon/>0114913115 </a>   </li>
                            <li> <a href="mailto:info@msalshawi.com"  target="_blank"><MailOutlinedIcon/> info@msalshawi.com      </a>  </li>
                          </ul>
                       </div>
                  </div>


                  <div className="map-footer">
                       <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3624.689354408845!2d46.7762369!3d24.7032033!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f06d2f776d9a9%3A0x4697d5e4f7e3972c!2sSheikh%20Muhammed%20Salih%20Al-Shawi%20Foundation!5e0!3m2!1sen!2seg!4v1611479906779!5m2!1sen!2seg" width="750px" height="400" frameborder="0" className="map-iframe" style={{borderRadius:20}} allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                  </div>

            
            </div>
        </Grid>
      </Grid>
       
  </footer>
  );
};

export default Footer;
